// pages/Home.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, Users, Sparkles, Shield, Zap } from 'lucide-react';
import styles from '../styles/home.module.css';

function Home() {
  const navigate = useNavigate();

  return (
    <div className={styles.homePage}>
      <div className={styles.container}>
        <div className={styles.heroSection}>
          <div className={styles.heroIcon}>💬</div>
          <h1 className={styles.heroTitle}>
            Welcome to <span className={styles.gradientText}>Chatting Club</span>
          </h1>
          <p className={styles.heroSubtitle}>
            Connect with friends, meet new people, and chat in real-time
          </p>
        </div>

        <div className={styles.features}>
          <div className={styles.featureItem}>
            <div className={styles.featureIcon}>👥</div>
            <span>Find Friends</span>
          </div>
          <div className={styles.featureItem}>
            <div className={styles.featureIcon}>💬</div>
            <span>Real-time Chat</span>
          </div>
          <div className={styles.featureItem}>
            <div className={styles.featureIcon}>🔒</div>
            <span>Secure & Private</span>
          </div>
        </div>

        <button 
          className={styles.startButton}
          onClick={() => navigate('/users')}
        >
          <MessageCircle className={styles.buttonIcon} size={24} />
          <span>Start Chatting Now</span>
          <Sparkles className={styles.sparkleIcon} size={18} />
        </button>

        <p className={styles.footerText}>
          Join thousands of active users in the Chatting Club community
        </p>
      </div>
    </div>
  );
}

export default Home;